var map = {
	"./aerocamara.png": 50,
	"./aerosol.png": 157,
	"./agitar.png": 386,
	"./calidad3.png": 291,
	"./contento.png": 434,
	"./destapar.png": 674,
	"./dosificar.png": 948,
	"./enrasar.png": 254,
	"./grifo.png": 424,
	"./inhalador.png": 498,
	"./inhaladorApretado.png": 912,
	"./inhaladorParado.png": 967,
	"./jarabe.png": 627,
	"./jarabe_inicial.png": 703,
	"./logofarma.png": 112,
	"./marca.png": 358,
	"./mascara.png": 456,
	"./selloSitioWebArial.png": 242,
	"./sentado.png": 138,
	"./tabla.png": 878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;